import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.55;
        transform: scale(0.96);
    }
`;

export const Container = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    background-color: #fff;

    height: 100vh;
    width: 100vw;

    z-index: 9999;
`;


export const ImageContainer = styled.div`
    height: 100vh;
    width: 100vw;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ImageHolder = styled.img`
    width: 200px;
    height: 200px;
    object-fit: contain;

    animation: ${pulse} 1.6s ease-in-out infinite;
`;